import { render, staticRenderFns } from "./GoodCatalog.vue?vue&type=template&id=387bf182&"
import script from "./GoodCatalog.vue?vue&type=script&lang=js&"
export * from "./GoodCatalog.vue?vue&type=script&lang=js&"
import style0 from "./GoodCatalog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports